/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SpuntaValore } from './spunta-valore';


export interface Documento { 
    documento_id: string;
    versione: number;
    spunte: Array<SpuntaValore>;
}

